<template>
    <div>
        <b-modal id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-reaname-member-class-school" @hidden="resetModal">
            <div class="container wrap-form-change-name-class-school">
                <h4>
                    <strong>Bạn có chắc chắn muốn chuyển toàn bộ đề ra khỏi thư mục {{ folderItem.name }}</strong>
                </h4>
                <div class="form_action display-flex justity-content-space-around">
                        <button type="button"
                            class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading" @click="handleHideModal">
                            Hủy
                        </button>
                        <button type="button"
                        @click="handleSubmit"
                            class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading">
                            Đồng ý
                        </button>
                    </div>
            </div>

        </b-modal>
    </div>
</template>

<script>
import {moveAllOutFolder} from './../../../_api/folderExcerciseClassSchoolServices'
export default {
    name: "ModalChangeNameFolder",
    props: {
        folderItem: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        }
    },
    components: {
       
    },
    data() {
        return {
            confirmActive: {},
            submitted: false,
            isLoading: false,
            
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },

    },
    mounted() {
        this.handleShowModal()
    },

    methods: {
        handleSubmit(){
            let self = this
            moveAllOutFolder({id:this.folderItem.id}).then((res)=>{
                if (res && res.data && !res.errors) {
                    self.$toast.success('Di chuyển toàn bộ đề thi ra khỏi thư mục thành công')
                    this.handleDone()
                }
            })
        },
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        
        resetModal() {
            console.log('resetModal')
            
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-reaname-member-class-school'].toggle('#toggle-btn')
        },
        handleHideModal() {
            //this.$refs['modal-reaname-member-class-school'].hide()
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-reaname-member-class-school'].show()
        },
        
    }
}
</script>

<style lang="scss" scoped>

.wrap-form-change-name-class-school {
    padding-top: 20px;
    background-color: white;
    .wrap-list-excersice {
        margin-top: 20px;
    }

    #listExcersice {
        overflow: auto;
        max-height: 10rem;
        border-radius: 15px;
        border: 1px solid #cdd4da;
        padding: 5px;
        background: #e5e5e5;
    }
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-around {
    justify-content: space-around
}
</style>